import { apiFetch } from '../../api/api';
import { SERVER_URL } from '../../constants/server-type';

const BASE      = SERVER_URL.replace(/\/+$/, '');
const LIVE_BASE = `${BASE}/live`;
/**
 * GET live printers (Redis-backed)
 */
export async function fetchLivePrinters() {
  const data = await apiFetch("/printmanager/printers");
  return data;
}

export async function getPrinterPrefs(printerId) {
  const encodedId = encodeURIComponent(printerId);
  const data = await apiFetch(`/pm/printers/${encodedId}/prefs`);
  return data;
}


export async function fetchPrinterGroups() {
const res = await apiFetch(`/api/printmanager/printergroups`); // returns [{_id, name, description}]
return res;
}

export async function savePrinterPrefs(printerId, prefs) {
  const body=prefs;
  const data = await apiFetch(`/api/printmanager/${printerId}/prefs`, { method: 'PATCH', body });
  return data;
}


// Generic JSON fetch with timeout, cache-busting on GET, and cookies
async function j(base, path, opts = {}) {
  const isGet = !opts.method || opts.method.toUpperCase() === 'GET';
  const clean = String(path).replace(/^\/+/, '');
  const url = isGet ? `${base}/${clean}?t=${Date.now()}` : `${base}/${clean}`;

  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), opts.timeoutMs ?? 15000);

  try {
    const res = await fetch(url, {
      credentials: 'include',
      cache: 'no-store',
      signal: controller.signal,
      headers: {
        'Content-Type': 'application/json',
        ...(opts.headers || {})
      },
      ...opts,
      body: opts.body ? JSON.stringify(opts.body) : undefined,
    });

    if (!res.ok) {
      const text = await res.text().catch(() => '');
      throw new Error(`${opts.method || 'GET'} ${url} -> ${res.status} ${text}`.trim());
    }

    const ct = (res.headers.get('content-type') || '').toLowerCase();
    return ct.includes('application/json') ? res.json() : res.text();
  } finally {
    clearTimeout(timeout);
  }
}

const jLive = (p, o) => j(LIVE_BASE, p, o);

export const testPrint = (name, body) =>
  jLive(`printer/${encodeURIComponent(name)}/test-print`, { method: 'POST', body });
